import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import Time from "../components/time";
import { Link, useNavigate  } from "react-router-dom";


const Diesel_report_hire = () => {
  useAuthRedirect();
  const [data, setData] = useState([]); 
  const [branches, setBranches] = useState([]);
  
  const storedBranch = localStorage.getItem("branch"); // Default branch from storage
  const [selectedBranch, setSelectedBranch] = useState(storedBranch || ""); 
  const navigate = useNavigate();
   const [filteredData, setFilteredData] = useState([]);
      const [currentPage, setCurrentPage] = useState(1);
      const [itemsPerPage] = useState(10);
      const [searchTerm, setSearchTerm] = useState("");
        const [loading, setLoading] = useState(false);

        const canView  = hasPermission("Diesel Report", "view");
  

  // Fetch branches only once
  useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/diesel_report_hire")
      .then((response) => {
        setBranches(response.data.branches);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/diesel_report_hire?branch_code=${selectedBranch}`
        );
        setData(response.data.vehicles);
        setFilteredData(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      } finally {
        setLoading(false);
      }
    };

    if (selectedBranch) {
      fetchData();
    }
  }, [selectedBranch]);


  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.fld_vehno || "").toLowerCase().includes(term) ||
    String(item.fld_vtype || "").toLowerCase().includes(term) ||
    String(item.fld_vname || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };

  
  const handleSelection = (event) => {
    const value = event.target.value;
    if (value) {
      navigate('/diesel_report_list');
    }
  };

     if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Diesel Report - Hire</h2>
          <div>
            <Time />
          </div>
        </section>

        <div className="vehicle-class">
  <div>
    <p>Branch wise Report :</p>
        <select 
          value={selectedBranch} 
          onChange={(e) => setSelectedBranch(e.target.value)} 
          required 
          className="branch-select"
        >
          <option value="">Select Branch</option>
          {branches.map((item) => (
            <option key={item.branchMaster_code} value={item.branchMaster_code}>
              {item.branchMaster_name}
            </option>
          ))}
        </select>  </div>

  <div>
    <p>Select your vehicle:</p>
    <select className="branch-select" onChange={handleSelection}>     
          <option value="/hire">Hire Vehicle</option> 
        <option value="/own">Own Vehicle</option>    
    </select>
  </div>
</div>


       
        <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by vehicleName" value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>
        <div className="content-table">
         <table>
                     <thead>
                       <tr>
                         <th>S.No</th>
                          
                         <th>Vehicle Code</th>
                         <th>Vehicle Number</th>
                          
                         <th>Vehicle Name</th>
                         <th>Vehicle Type</th>
                         
                       </tr>
                     </thead>
                     <tbody>
                                   {loading ? (
                                     <tr>
                                       <td colSpan="6" className="loading-text">
                                         Loading data, please wait...
                                       </td>
                                     </tr>
                                   ) : currentData.length > 0 ? (
                                     currentData.map((item, index) => (
                                      <tr key={index}>
                                      <td>{indexOfFirstItem + index + 1}</td>
                                     <td>
                                       <Link to={`/vehicle_diesel_report_view_hire/${item.fld_vcode}/${item.branch_code}`}>{item.fld_vcode}</Link>
                                             </td>
                                      <td>{item.fld_vehno}</td>
                                       
                                      <td>{item.fld_vname}</td>  
                                      <td>{item.fld_vtype}</td>   
                                     
                                      
                                    </tr>
                                     ))
                                   ) : (
                                     <tr>
                                       <td colSpan="6">No Data Available</td>
                                     </tr>
                                   )}
                                 </tbody>
                   </table>
        </div>
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Diesel_report_hire;
